import { render, staticRenderFns } from "./TenantCard.vue?vue&type=template&id=3273215e&scoped=true&"
import script from "./TenantCard.vue?vue&type=script&lang=js&"
export * from "./TenantCard.vue?vue&type=script&lang=js&"
import style0 from "./TenantCard.vue?vue&type=style&index=0&id=3273215e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273215e",
  null
  
)

export default component.exports